<template>
  <div class="tabs">
    <van-tabs v-model="active" sticky :offset-top="45" title-inactive-color="#666" title-active-color="#333" animated swipeable :border="false">
      <van-tab v-for="(item,index) in categoreis" :name="item.id" :key="index">
        <div class="" slot="title" @click="changeTab(item,index)">{{item.categoryName}}</div>
        <comodityItem :goodss="item.goodss" :goodssId="item.id" :activity="activity" :active="active" :title="item.categoryName"/>
      </van-tab>

    </van-tabs>
    
  </div>
</template>
<script>
import comodityItem from './commodityitem';
import utils from "@/utils/common";
export default {
  data() {
    return {
        active:-1,
    };
  },
  props:{
    categoreis:{
      default:function(){
        return []
      },
      type:Array
    },
    activity:{
      default:function(){return{}},
      type:Object
    }
  },
  methods:{
    changeTab(item,index){
      gio("track", "flowLocationClick", {entryType_vara:'品类导航',position_var:index,positonName_var:item.categoryName});
      utils.nativeMethod({tm:'4000101',tp:{module_evar:'品类导航'}})
    }
  },
  components:{comodityItem}
};

</script>
<style lang="less" scoped>
.tabs{
  /deep/ .van-tabs__line{
    background-color: #F8D541
   }
}
</style>